module.exports = __webpack_public_path__ + "img/handover.6f7b84db.png";